import { useState } from 'react'

import { Box, Grid, LinearProgress, Paper, Typography } from '@mui/material'

import { CardTitle } from 'components/common/controls'
import { DriverLocationTrackingReportInputDtoInput } from 'generated/graphql'

import FilterCriteria from './FilterCriteria'
import LiveTrackingChart from './LiveTrackingChart'
import { useDriverLocationTracking } from './useDriverLocationTracking'

const DriverLocationTracking = () => {
  const [activeFilter, setActiveFilter] =
    useState<DriverLocationTrackingReportInputDtoInput | null>(null)

  const { dataPoints, loading, progress, fetchData } = useDriverLocationTracking()

  const loadPercent = progress.total > 0 ? Math.round((progress.completed / progress.total) * 100) : 0

  const handleViewReport = (filter: DriverLocationTrackingReportInputDtoInput) => {
    setActiveFilter(filter)
    fetchData(filter)
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper variant='outlined'>
          <Box p={2}>
            <CardTitle>Filter Criteria</CardTitle>
            <FilterCriteria onViewReport={handleViewReport} onClear={() => setActiveFilter(null)} />
          </Box>
        </Paper>
      </Grid>

      {activeFilter !== null && (
        <Grid item xs={12}>
          <Paper variant='outlined'>
            <Box p={2} sx={{ position: 'relative' }}>
              {loading && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 2,
                  }}>
                  <LinearProgress
                    variant='determinate'
                    value={loadPercent}
                    sx={{ height: 4, borderRadius: 0 }}
                  />
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      px: 1,
                      pt: 0.5,
                    }}>
                    <Typography
                      variant='caption'
                      sx={{
                        backgroundColor: 'background.paper',
                        px: 0.75,
                        py: 0.25,
                        borderRadius: 1,
                        opacity: 0.9,
                        lineHeight: 1.4,
                      }}>
                      Loading {loadPercent}%…
                    </Typography>
                  </Box>
                </Box>
              )}
              <LiveTrackingChart dataPoints={dataPoints} filter={activeFilter} />
            </Box>
          </Paper>
        </Grid>
      )}
    </Grid>
  )
}

export default DriverLocationTracking
